'use client';

import { BadgeHelp, StickyNote, ShieldOff } from "lucide-react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { routing } from "@/i18n/routing";

export default function Forbidden() {
  const t = useTranslations('ForbiddenPage');
  const { localePrefix } = routing;
  const navigations = [
    {
      icon: <BadgeHelp className="w-6 h-6" />,
      title: t("support.title"),
      desc: t("support.desc"),
      href: "https://www.power2go.com.br/suporte"
    },
    {
      icon: <StickyNote className="w-6 h-6" />,
      title: "Página Inicial",
      desc: t("homePage.desc"),
      href: `${localePrefix}/home`
    }
  ]

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-background text-foreground transition-colors">
      <div className="max-w-lg w-full text-center">
        <ShieldOff size={64} className="mx-auto mb-4 text-muted-foreground" />
        <p className="text-3xl font-semibold sm:text-4xl">
          {t("accessDenied")}
        </p>
        <p className="mt-2 text-muted-foreground">
          {t("forbiddenMessage")}
        </p>

        <div className="mt-12 text-left">
          <ul className="divide-y divide-muted-foreground/20 dark:divide-muted">
            {navigations.map((item, idx) => (
              <li key={idx} className="flex gap-x-4 py-6">
                <div className="flex-none w-14 h-14 bg-red-100 dark:bg-red-900 rounded-full text-red-600 dark:text-red-300 flex items-center justify-center">
                  {item.icon}
                </div>
                <div className="space-y-1">
                  <h4 className="font-medium text-foreground">{item.title}</h4>
                  <p className="text-muted-foreground">{item.desc}</p>
                  <Link
                    href={item.href}
                    className="text-sm text-red-600 dark:text-red-300 hover:text-red-500 dark:hover:text-red-400 font-medium inline-flex items-center gap-x-1"
                  >
                    {t("access")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="w-5 h-5"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5 10a.75.75 0 01.75-.75h6.638L10.23 7.29a.75.75 0 111.04-1.08l3.5 3.25a.75.75 0 010 1.08l-3.5 3.25a.75.75 0 11-1.04-1.08l2.158-1.96H5.75A.75.75 0 015 10z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
